import { render } from "./MdTextarea.vue?vue&type=template&id=a6206876"
import script from "./MdTextarea.vue?vue&type=script&lang=js"
export * from "./MdTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__